import * as THREE from 'three'
import React from 'react'
import { useLoader } from '@react-three/fiber'
import { useFrame } from '@react-three/fiber'
import { useRef, useState, useEffect } from 'react'

import s1 from '../assets/stats/s1.png'
import s2 from '../assets/stats/s2.png'
import s3 from '../assets/stats/s3.png'
import s4 from '../assets/stats/s4.png'
import s5 from '../assets/stats/s5.png'
import s6 from '../assets/stats/s6.png'
import statshead from '../assets/screen3/Stats.png'
import insta from '../assets/socialIcons/instagram2.png'
import twitter from '../assets/socialIcons/twitter2.png'
import youtube from '../assets/socialIcons/youtube2.png'
import linkedin from '../assets/socialIcons/linkdin2.png'
import facebook from '../assets/socialIcons/facebook2.png'

function Layers(data) {
            const texture = useLoader(THREE.TextureLoader, data.imgname)
            return (
            <mesh position={data.pos}>
                <planeBufferGeometry attach="geometry" args={data.args} />
                <meshBasicMaterial attach="material" map={texture} transparent />
            </mesh>
            )
}

function Stats(data) {
    const ref = useRef();
            const [hovered, setHovered] = useState(false)
            const texture = useLoader(THREE.TextureLoader, data.imgname)
            useFrame(() => {
                if (hovered) {
                  ref.current.scale.set(1.1, 1.1, 1.1)
                } else {
                  ref.current.scale.set(1, 1, 1)
                }
              })
            return (
            <mesh ref={ref} position={data.pos}  onPointerOver = {()=> {setHovered(true)}} onPointerOut = {()=> {setHovered(false)}}>

                <planeBufferGeometry attach="geometry" args={data.args} />
                <meshBasicMaterial attach="material" map={texture} transparent />
            </mesh>
            )
}

function SocialIcons1(data) {
    
    const ref = useRef();
            const [hovered, setHovered] = useState(false)
            const texture = useLoader(THREE.TextureLoader, data.imgname)
            useFrame(() => {
                if (hovered) {
                  ref.current.scale.set(1.1, 1.1, 1.1)
                } else {
                  ref.current.scale.set(1, 1, 1)
                }
              })
              const MyClick = () => {window.open(data.link)}

              useEffect(() => {
                document.body.style.cursor = hovered ? 'pointer' : 'auto'
              }, [hovered])
            return (
            <mesh ref={ref} position={data.pos} onClick={MyClick} onPointerOver = {()=> {setHovered(true)}} onPointerOut = {()=> {setHovered(false)}}>

                <planeBufferGeometry attach="geometry" args={data.args} />
                <meshBasicMaterial attach="material" map={texture} transparent />
            </mesh>
            )
}

export default function Screen4() {
    return (
        <>
            <SocialIcons1 pos={[212,4,-25]} args={[1.5,1.5]} imgname={insta}     link="https://www.instagram.com/antaragni.iitkanpur/" />
            <SocialIcons1 pos={[212,2,-25]} args={[1.5,1.5]} imgname={twitter}   link="https://twitter.com/antaragni" />
            <SocialIcons1 pos={[212,0,-25]} args={[1.5,1.5]} imgname={youtube}   link="https://www.youtube.com/user/antaragniiitkanpur" />
            <SocialIcons1 pos={[212,-2,-25]} args={[1.5,1.5]} imgname={linkedin} link="https://www.linkedin.com/company/antaragni-iit-kanpur/mycompany/" />
            <SocialIcons1 pos={[212,-4,-25]} args={[1.5,1.5]} imgname={facebook} link="https://www.facebook.com/antaragni.iitk/" />

            <Stats pos={[164,-4,-25]} args={[8,8]} imgname={s2} />
            <Stats pos={[164,2,-25]}  args={[8,8]}imgname={s4} />
            <Stats pos={[174,-4,-25]} args={[8,8]} imgname={s3} />
            <Stats pos={[174,2,-25]}  args={[8,8]}imgname={s1} />
            <Stats pos={[184,-4,-25]} args={[8,8]} imgname={s6} />
            <Stats pos={[184,2,-25]}  args={[8,8]}imgname={s5} />
            <Layers pos={[174,3,-25]} args={[15,15]} imgname={statshead}/>


          
        </>
    )
}